import type { ComponentProps } from "react";
import { LuChartBarBig as LuBarChartHorizontalBig } from "react-icons/lu";

import { EDITOR_MEDIA_TAB } from "@/components/app/editor-v3/constants";
import { Button } from "@/components/ui/button";

import { useEditorContext } from "../editor-context";

export const EditorActionPoll = ({
  children,
  ...props
}: ComponentProps<typeof Button>) => {
  const { setEditorContext, activeMediaTab } = useEditorContext();

  return (
    <Button
      {...props}
      onClick={() => {
        setEditorContext({
          activeMediaTab:
            activeMediaTab === EDITOR_MEDIA_TAB.Poll
              ? null
              : EDITOR_MEDIA_TAB.Poll,
        });
      }}
    >
      <LuBarChartHorizontalBig className="text-lg" />
      {children}
    </Button>
  );
};
